import type * as React from 'react';

export const Resources: React.FC<React.SVGProps<SVGSVGElement>> = props => {
	return (
		<svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 0H10.6667C11.402 0 12 0.598 12 1.33333V4C12 4.73533 11.402 5.33333 10.6667 5.33333H8C7.26467 5.33333 6.66667 4.73533 6.66667 4V1.33333C6.66667 0.598 7.26467 0 8 0ZM8 4V1.33333H10.6667L10.6673 4H8ZM1.33333 6.66667H4C4.73533 6.66667 5.33333 7.26467 5.33333 8V10.6667C5.33333 11.402 4.73533 12 4 12H1.33333C0.598 12 0 11.402 0 10.6667V8C0 7.26467 0.598 6.66667 1.33333 6.66667ZM8 6.66667H10.6667C11.402 6.66667 12 7.26467 12 8V10.6667C12 11.402 11.402 12 10.6667 12H8C7.26467 12 6.66667 11.402 6.66667 10.6667V8C6.66667 7.26467 7.26467 6.66667 8 6.66667ZM8 8V10.6667H10.6673L10.6667 8H8ZM1.33333 10.6667V8H4L4.00067 10.6667H1.33333ZM1.33333 4V1.33333H4L4.00067 4H1.33333ZM1.33333 0H4C4.73533 0 5.33333 0.598 5.33333 1.33333V4C5.33333 4.73533 4.73533 5.33333 4 5.33333H1.33333C0.598 5.33333 0 4.73533 0 4V1.33333C0 0.598 0.598 0 1.33333 0Z"
				fill="currentColor"
			/>
		</svg>
	);
};
